// extracted by css-extract-rspack-plugin
export default {"container":"CompactThread-module__container__OlM6N","comments":"CompactThread-module__comments__wl5Ob","moreReplies":"CompactThread-module__moreReplies__VSa_Z"};